import React, { useState } from 'react';
import isNil from 'lodash/isNil';

import nocover from '../../../../img/nocover.png';

interface Props {
    title?: string;
    productId?: string;
    coverUrl?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    minSizeInPx: number;
    className?: string;
}

export const ProductCover = (props: Props) => {
    const [isError, setIsError] = useState(false);

    const { title, coverUrl, productId, onMouseEnter, onMouseLeave, minSizeInPx = 300, className } = props;

    if (isError || isNil(coverUrl)) {
        // noinspection HtmlUnknownTarget
        return (
            <img
                src={nocover}
                alt="cover currently not available"
                title={`${title} - Cover currently not available`}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                className={className}
            />
        );
    } else {
        const src = coverUrl ? coverUrl : `https://covers.borrowbox.com/v3/covers/${productId}?w=${minSizeInPx}`;

        return (
            <img
                src={src}
                alt={title}
                title={title}
                onError={() => setIsError(true)}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                className={className}
            />
        );
    }
};
